function initContactForm() {

	$('.contact-form').validate({
		submitHandler: function () {
			var data = $('.contact-form').serialize();
			var object = {
				'success': function (response) {
					$('.contact-form .form-response').removeClass('alert-success');
					$('.contact-form .form-response').removeClass('alert-danger');

					if (response['status'] == 'ok') {
						$('.contact-form .form-response').addClass('alert-success').show().html(response['message']);
					} else {
						$('.contact-form .form-response').addClass('alert-danger').show().html(response['error']);
					}
				},
				'data': data
			};
			$.ajax(object);
			return false;
		},
		errorPlacement: function (error, element) {
			// error.hide();
		},
		highlight: function (element, errorClass, validClass) {
			$(element).parent().find('.form-control-feedback').remove();
			$(element).closest('.form-group').append('<span class=" form-control-feedback"><i class="fa fa-exclamation-triangle"></i></span>');
			$(element).parent().addClass('has-error has-feedback');
		},
		unhighlight: function (element, errorClass, validClass) {
			$(element).parent().find('.form-control-feedback').remove();
			$(element).parent().removeClass('has-error has-feedback');
		}
	});
}

 

function initRegistrationForm() {
	$(".datepicker").datepicker({
		format: 'dd MM, yyyy',
		language: "el",
		autoclose: true
	});


	$('.registration-form').validate({
		submitHandler: function () {
			
        	if (typeof (grecaptcha) !== 'undefined') {
                grecaptcha.ready(function () {
                    grecaptcha.execute(RECAPTCHA_KEY, { action: 'submit' }).then(function (token) {
                      $('#registration-form').append('<input class="gr-recaptcha" name="g-recaptcha-response" type="hidden" value="'+token+'"/>');
                       var data = $('#registration-form').serialize();
                        var submitButton = $('form[name="registration-form"] .submit-btn');
						submitButton.attr('disabled','disabled');

						$.ajax({
							data: data,
							success: function (response) {
								if(response.status==='ok')
								{
									actionResponseModal("Ευχαριστούμε για το ενδιαφέρον σας!", "success");

									if($('#registration-form').find('.gr-recaptcha').length>0 ){
				                        $('#registration-form').find('.gr-recaptcha').remove();
				                    }


									$('#responseModal').on('hidden.bs.modal', function () {
										setTimeout(function () {
											window.location.reload();
										}, 1000);
									});
								}else{
									actionResponseModal( response.error || "Παρουσιάστηκε σφάλμα", "error");
									submitButton.removeAttr('disabled');
									if($('#registration-form').find('.gr-recaptcha').length>0 ){
				                        $('#registration-form').find('.gr-recaptcha').remove();
				                    }
								}
							},
							error: function (data) {
								actionResponseModal( data.error || "Παρουσιάστηκε σφάλμα", "error");
								submitButton.removeAttr('disabled');
								if($('#registration-form').find('.gr-recaptcha').length>0 ){
			                        $('#registration-form').find('.gr-recaptcha').remove();
			                    }
							},
						});


                    });
                });
            }
       
			return false;
		},
		errorPlacement: function (error, element) {
			// error.hide();
		},
		highlight: function (element, errorClass, validClass) {
			$(element).parent().find('.form-control-feedback').remove();
			$(element).closest('.form-group').append('<span class=" form-control-feedback"><i class="fa fa-exclamation-triangle"></i></span>');
			$(element).parent().addClass('has-error has-feedback');
		},
		unhighlight: function (element, errorClass, validClass) {
			$(element).parent().find('.form-control-feedback').remove();
			$(element).closest('.form-group').find('.form-control-feedback').remove();
			$(element).parent().removeClass('has-error has-feedback');
		}
	});
}


function validatePrintRegistrationForm() {

	if( !$('.registration-form').valid() ){
		$('html, body').animate({
			scrollTop: $("#registration-form").offset().top - 150
		}, 0);
		return false; 
	}
	window.print();
	return false; 
}

function actionResponseModal(msg, type, persist, close_cb) {
	var $timeout = 0;

	
	setTimeout(function () {
		var $d = $('#responseModal').html();

		if ($("#responseModal").length == 0) {
			$("body").append($d);
		}


		var modal_content = '';
		if (type == "success") {
			var icon = `<svg xmlns="http://www.w3.org/2000/svg" class="w-14 shrink-0 fill-green-500 inline" viewBox="0 0 512 512">
					<path d="M383.841 171.838c-7.881-8.31-21.02-8.676-29.343-.775L221.987 296.732l-63.204-64.893c-8.005-8.213-21.13-8.393-29.35-.387-8.213 7.998-8.386 21.137-.388 29.35l77.492 79.561a20.687 20.687 0 0 0 14.869 6.275 20.744 20.744 0 0 0 14.288-5.694l147.373-139.762c8.316-7.888 8.668-21.027.774-29.344z" data-original="#000000"></path>
					<path d="M256 0C114.84 0 0 114.84 0 256s114.84 256 256 256 256-114.84 256-256S397.16 0 256 0zm0 470.487c-118.265 0-214.487-96.214-214.487-214.487 0-118.265 96.221-214.487 214.487-214.487 118.272 0 214.487 96.221 214.487 214.487 0 118.272-96.215 214.487-214.487 214.487z" data-original="#000000"></path>
				</svg>`;

			modal_content = `<p class="text-center pt-3 mb-4 px-3">Η φόρμα σας έχει υποβληθεί επιτυχώς.<br>
			 </p>
		<button class="mb-4 close-modal-btn btn" data-dismiss="modal" aria-label="Close">OK</button>`;
		} else {
			var icon = `<svg xmlns="http://www.w3.org/2000/svg" class="error-modal-icon" viewBox="0 0 286.054 286.054">
					<path fill="#e2574c" d="M143.027 0C64.04 0 0 64.04 0 143.027c0 78.996 64.04 143.027 143.027 143.027 78.996 0 143.027-64.022 143.027-143.027C286.054 64.04 222.022 0 143.027 0zm0 259.236c-64.183 0-116.209-52.026-116.209-116.209S78.844 26.818 143.027 26.818s116.209 52.026 116.209 116.209-52.026 116.209-116.209 116.209zm.009-196.51c-10.244 0-17.995 5.346-17.995 13.981v79.201c0 8.644 7.75 13.972 17.995 13.972 9.994 0 17.995-5.551 17.995-13.972V76.707c-.001-8.43-8.001-13.981-17.995-13.981zm0 124.997c-9.842 0-17.852 8.01-17.852 17.86 0 9.833 8.01 17.843 17.852 17.843s17.843-8.01 17.843-17.843c-.001-9.851-8.001-17.86-17.843-17.86z" data-original="#e2574c"></path>
				</svg>`;

			modal_content = `<p class="text-center pt-3 mb-4 px-3">Παρακαλούμε ξαναπροσπαθήστε.</p>
					  <button class="mb-4 close-modal-btn btn" data-dismiss="modal" aria-label="Close">OK</button>`;
		}

		var content =
			` <div class="confirm-modal-exclamation d-table mx-auto mt-4 py-4 icon-` +
			type +
			`" >` +
			icon +
			`</div></div>`;

		content += `<h4 class="modal-title text-center mt-2">` + msg + `</h4> ${modal_content} `;

		$("#responseModal .modal-content").html(content);
		$("body").addClass("dark-backdrop");
		$("#responseModal")
			.modal("show");
	}, $timeout);
}
function initEmailAlert() {

	$('.email-alert-form').validate({
		submitHandler: function () {
			var data = $('.email-alert-form').serialize();
			var object = {
				'success': function (response) {
					$('.email-alert-form .form-response').removeClass('alert-success');
					$('.email-alert-form .form-response').removeClass('alert-danger');

					if (response['status'] == 'ok') {
						$('.email-alert-form .form-response').addClass('alert-success').show().html(response['message']);
					} else {
						$('.email-alert-form .form-response').addClass('alert-danger').show().html(response['error']);
					}
				},
				'data': data
			};
			$.ajax(object);
			return false;
		},
		errorPlacement: function (error, element) {
			// error.hide();
		},
		highlight: function (element, errorClass, validClass) {
			$(element).parent().find('.form-control-feedback').remove();
			$(element).closest('.form-group').append('<span class=" form-control-feedback"><i class="fa fa-exclamation-triangle"></i></span>');
			$(element).parent().addClass('has-error has-feedback');
		},
		unhighlight: function (element, errorClass, validClass) {
			$(element).parent().find('.form-control-feedback').remove();
			$(element).parent().removeClass('has-error has-feedback');
		}
	});
}




function initContactMap() {
	"use strict";
	$.ajax({
		url: '//maps.googleapis.com/maps/api/js?key=AIzaSyAPyGu0Ic6jqnDfIlKJWn3jjX2tJxTIcPE',
		dataType: "script",
		success: function () {
			if (typeof $('#map-container-contact')[0] !== "undefined") {

				var map_styling = [
					{
						"featureType": "administrative",
						"elementType": "labels.text.fill",
						"stylers": [{
							"color": "#444444"
						}]
					}, {
						"featureType": "landscape",
						"elementType": "geometry",
						"stylers": [{
							"color": "#254169"
						}]
					}, {
						"featureType": "poi",
						"elementType": "all",
						"stylers": [{
							"visibility": "off"
						}]
					}, {
						"featureType": "road",
						"elementType": "geometry",
						"stylers": [{
							"visibility": "on"
						}, {
							"lightness": 45
						}]
					},
					{
						"featureType": "road",
						"elementType": "labels",
						"stylers": [{
							"visibility": "off"
						}, {
							"lightness": 45
						}]
					},
					{
						"featureType": "road.highway",
						"elementType": "geometry",
						"stylers": [{
							"visibility": "simplified"
						}]
					}, {
						"featureType": "road.arterial",
						"elementType": "labels.icon",
						"stylers": [{

							"visibility": "off"
						}]
					},

					{
						"featureType": "transit",
						"elementType": "all",
						"stylers": [{
							"visibility": "off"
						}]
					}, {
						"featureType": "water",
						"elementType": "all",
						"stylers": [{
							"color": "#254169"
						}, {
							"visibility": "on"
						}]
					}];



				var myLatlng_contact = new google.maps.LatLng(38.0474733, 23.8029528);
				var infowindow = new google.maps.InfoWindow({});
				var options = {
					zoom: 16,
					center: myLatlng_contact,
					styles: map_styling,
					scrollwheel: false,
					navigationControl: false,
					mapTypeControl: false,
					scaleControl: false,
					draggable: false,
					disableDoubleClickZoom: true,
					zoomControl: false,
					disableDefaultUI: true,
					mapTypeId: google.maps.MapTypeId.ROADMAP
				};
				var map_contact = new google.maps.Map($('#map-container-contact')[0], options);
				var markerImage = new google.maps.MarkerImage(
					MAP_MARKER
				);

				var contentString =
					'<div id="content" class="maps_infobox">' +
					'<div id="siteNotice">' + '</div>' +
					'<img id="firstHeading" src="' + SKIN + 'img/logo.png" class="firstHeading">' +
					'<div id="bodyContent">' +
					'<p>&nbsp;</p>' +
					'<p><b>Star Bulk Carriers Corp.</b></p>' +
					'<p>c/o Star Bulk Management Inc.</p>' +
					'<p>40, Agiou Konstantinou Str., Maroussi 15124,</p>' +
					'<p>Athens, Greece</p>' +
					'<a target="_blank" href="https://maps.google.com?saddr=Current+Location&daddr=38.0478457,23.8040864">View Directions</a>'
				'</div>' +
					'</div>';
				infowindow = new google.maps.InfoWindow({ content: contentString });
				var marker = new google.maps.Marker({
					position: myLatlng_contact,
					map: map_contact,
					icon: markerImage
				});

				marker.addListener('click', function () {
					infowindow.open(map_contact, marker);
				});


			}

		}

	});

}


